<!-- Main Application Component -->

<template>
	<div id="app_shell">

		<WaitSpinner />
		<PopMgr /> <!-- Popup Modal Mgr -->

		<div id="app_body">

			<TheStartup v-if="!ready" />

			<!-- Stable area, no flex -->
			<div id="app_header" v-if="ready" >

				<!-- <TheMasthead /> -->

				<!-- <div class="rounded"> -->
				<UniMenu menu_id="user" menu_type="ico" :icoSize="35" :icoPad="4" :icoSpace="5" show_title="0" />
				<!-- </div> -->
				<UniMenu menu_id="admin" menu_type="ico" :icoSize="28" :icoSpace="2" show_title="0" class="topright" v-if="role=='adm'"/>
				<!-- <div class="clr" /> -->
				<!-- <UniMenu menu_id="links" menu_type="txt" /> -->
				<!-- <div class="clr" /> -->
				<!-- <UniMenu menu_id="bldUni" menu_type="txt" /> -->
				<!-- <div class="clr" /> -->
				<!-- <UniMenu menu_id="bldApp" menu_type="txt" /> -->
				<!-- <cmp-test /> -->
			</div>

			<!-- Content area, flex -->
			<div id="app_content" v-if="ready" >
				<router-view/>
			</div>

		</div>

		<!-- Stable areas, no flex -->
		<div class="app_spacer" />

		<div id="app_footer">
			<TheFooter />
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { mapState } from 'vuex';
import PopMgr from '@/components/PopMgr.vue';
import TheStartup from '@/components/TheStartup.vue';
import TheMasthead from '@/components/TheMasthead.vue';
import TheFooter from '@/components/TheFooter.vue';
// import Test from '@/components/Test.vue';
import { eventBus } from '@/main';

export default {
	data() {
		return {
			testTxt: "L\nM\nN\nO\nP",
		}
	},
	computed: {
		...mapState('app', ['ready', 'role']),
	 },
	components: {
		PopMgr,
		TheStartup,
		TheMasthead,
		TheFooter,
		// 'cmp-test': Test,
	},
	methods: {
		// Listen to "router" event on eventBus
		// We can change the route using the event bus
		// If the calling component has been dynamically created
		// and does not have access to this.$route.push(path)
		handleRouter(route) {
			m("app handle router", route);
			this.$router.push(route).
				catch(err => {
					// m(err);
				})
		}
	},
	created() {
		m("app created");
		eventBus.$on('router', this.handleRouter);
	},
	beforeDestroy() {
		m("app before destroy");
		eventBus.$off('router', this.handleRouter);
	},
	mounted() {
		m("app mounted");
	}
}

</script>

<style>

#app_shell {
	position: relative;
	display:flex;
	flex-direction: column;
	min-width: 330px;
	max-width: 600px;
	height: 85vh;		
	/* height: 560px;		 */
	min-height: 560px;
	overflow: hidden;
	margin: 0 auto;
	border: solid 0px #999;
}

#app_popup_container {
	border: solid 0px #C30;
}

#app_body {
	display:flex;
	overflow: hidden;
	flex-direction: column;
	flex: 1;
	border-radius: 6px;
	border: solid 0px #999;
}

#app_header {
	position: relative;
	overflow: hidden;
	background-color: #FCF9F3;
	/* border: solid 0px #090; */
	/* border-bottom: solid 1px #999; */
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: solid 1px #999;
}

#app_content {
	clear:both;
	flex: 1;
	overflow: hidden;
	background-color: #EEE;
	border-bottom-left-radius: 6px;
	border-bottom-right-radius: 6px;
	border: solid 1px #999;
	border-top: solid 0px #C30;
}
.clr {
	clear:both;
	width: 0px;
	height: 0px;
	overflow: hidden;
	border: solid 0px #000;
}
.app_spacer {
	clear:both;
	height:4px;
	overflow: hidden;
	border: solid 0px #F90;
}
#app_footer {
	clear:both;
	height: 40px;
	overflow: hidden;
	background-color: #EEE;
	border: solid 0px #999;
}

.rounded {
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: solid 1px #999;
}

.topright {
	position: absolute;
	top: 1px;
	right: 1px;
}

</style>
